<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { mapState } from "vuex";
import moment from "moment";
import Banners from "@/components/widgets/banners";
import Stat from "@/components/widgets/stat";
import ChartBonus from "@/components/widgets/chart-bonus";
import ChartOrders from "@/components/widgets/chart-orders";

export default {
  locales: {
    pt: {
      'Team': 'Time',
      'Dashboard': 'Painel',
      'Package': 'Pacote',
      'Graduation': 'Graduação',
      'Points': 'Pontos',
      'Referral link': 'Link de indicação',
      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.',
      'No records found.': 'Nenhum registro encontrado.',
      'Total Bonus': 'Total de Bônus',
      'Total Points': 'Total de Pontos',
    },
    es: {
      'Team': 'Equipo',
      'Dashboard': 'Panel',
      'Package': 'Paquete',
      'Graduation': 'Graduación',
      'Points': 'Puntos',
      'Referral link': 'Link de patrocineo',
      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtelo de nuevo más tarde.',
      'No records found.': 'No se encontraron registros.',
      'Total Bonus': 'Total de Bônus',
      'Total Points': 'Total de Puntos',
    }
  },
  components: {
    Layout,
    Banners,
    Stat,
    ChartBonus,
    ChartOrders
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      month_year: moment().format("MM/YY"),
      monthly: "inactive",

      points: {
        unilevel: '-',
        graduation: '-',
        premiation: '-',
      },

      total: {
        prediction: "R$ -,--",
        bonus: "R$ -,--",
        balance: "R$ -,--",
        points: {
          unilevel: 0,
          graduation: 0,
        },
      },

      statData: null,
      wallets: null,

      cart: {
        items: {
          loading: true,
          total: 0,
          list: null
        },
        points: {
          unilevel: 0,
          graduation: 0,
        },
        subtotal: '0.00',
        sale: '0.00',
        shipping: {
          method: '-',
          value: '-',
        },
        total: '0.00'
      },

      referral: {
        sponsored: process.env.VUE_APP_URL_PAINEL + this.$store.state.account.user.indication,
        clients: process.env.VUE_APP_URL_CLIENTS + this.$store.state.account.user.indication,
        usinas: process.env.VUE_APP_URL_USINAS + this.$store.state.account.user.indication,
      },

      card: '',

      informative: {
        id: null,
        title: null,
        cover: null,
        modal: false
      },

      payments: {
        pending: 0,
      },

      subscriptions: {
        pending: 0,
      },
    };
  },
  methods: {
    getMonthly() {
      api.get("reports/monthly").then((response) => {
        this.monthly = response.data.status;
        this.getStatData();
      });
    },
    getTotalPrediction() {
      api
        .get("reports/bonus/prediction").then((response) => {
          if (response.data.status == "success") {
            this.total.prediction = this.$options.filters.currency(
              response.data.total
            );
            this.getStatData();
          }
        });
    },
    getTotalBonus() {
      api
        .get('reports/bonus/total')
        .then(response => {
          if (response.data.status == 'success') {
            this.total.bonus = this.$options.filters.currency(response.data.total)
            this.getStatData();
          }
        })
    },
    getTotalBalance() {
      api
        .get('wallet/balance')
        .then(response => {
          if (response.data.status == 'success') {
            this.total.balance = this.$options.filters.currency(response.data.balance)
            this.getStatData();
          }
        })
    },
    getStatData() {
      this.statData = [
        {
          type: "line",
          icon: "bx-dollar",
          title: "Total de Bônus",
          value: this.total.bonus,
        },
        {
          type: "line",
          icon: "bx-wallet",
          title: "Saldo Disponível",
          value: this.total.balance,
        }
      ]
    },
    getInformative() {
      api
        .get('informatives/highlight')
        .then((response) => {
          if (response.data.status == 'success') {
            this.informative.id = response.data.informative.id
            this.informative.title = response.data.informative.title
            this.informative.cover = response.data.informative.cover
            if (this.informative.cover) {
              this.informative.modal = false;
              this.informative.modal = true;
            }
          }
        })
    },
    getSubscriptionsPaymentsPending() {
      api.get("subscriptions/payments/pending").then((response) => {
        if (response.data.status == 'success') {
          this.subscriptions.pending = response.data.payments;
        }
      });
    },

  },
  mounted() {
    this.getMonthly();
    this.getTotalPrediction();
    this.getTotalBonus();
    this.getTotalBalance();
    this.getStatData();
    this.getInformative();
    this.getSubscriptionsPaymentsPending();
  }
};
</script>

<template>
  <Layout>
    <router-link tag="a" to="/subscriptions" v-if="subscriptions.pending > 0" class="d-none">
      <div class="bg-soft-danger p-3 rounded mb-3 d-flex align-items-center">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path
              d="M2.634 17.918a1.765 1.765 0 0 0 1.201 1.291l.18.791H4v2h16v-2H6.683a.84.84 0 0 0-.007-.278l-.196-.863 10.357-2.356.196.863a.886.886 0 0 0 1.06.667l.863-.197a.885.885 0 0 0 .667-1.06l-.251-1.103c.446-.416.67-1.046.525-1.683l-.59-2.59a1.76 1.76 0 0 0-1.262-1.307l-2.049-3.378a2.774 2.774 0 0 0-2.982-1.263l-7.868 1.79a2.769 2.769 0 0 0-2.144 2.43l-.387 3.932a1.76 1.76 0 0 0-.57 1.724l.589 2.59zm3.02-.688a1.327 1.327 0 1 1-.59-2.589 1.327 1.327 0 0 1 .59 2.589zm11.222-2.552a1.328 1.328 0 1 1-.59-2.587 1.328 1.328 0 0 1 .59 2.587zM5.589 9.192l7.869-1.791a.773.773 0 0 1 .83.351l1.585 2.613-.566.129-10.046 2.287-.568.129.299-3.042a.772.772 0 0 1 .597-.676zM18.405 4 17 2l-.5 3L19 9l3 1-2-2.539 2-.933-2-.933L22 2z">
            </path>
          </svg>
        </div>
        <div class="ml-3">
          <h5 class="mb-0">Atenção!</h5>
          <p class="mb-0 text-dark">Você possui <strong class="font-size-16">{{ subscriptions.pending }}</strong> mensalidade(s) pendente(s).</p>
          <p class="mb-0 text-dark">Clique aqui para realizar o pagamento.</p>
        </div>
      </div>
    </router-link>

    <Banners></Banners>

    <div class="card mb-1">
      <div class="card-body py-2 d-flex align-items-center">
        <div class="mt-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path
              d="M8.465 11.293c1.133-1.133 3.109-1.133 4.242 0l.707.707 1.414-1.414-.707-.707c-.943-.944-2.199-1.465-3.535-1.465s-2.592.521-3.535 1.465L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.122-2.121z">
            </path>
            <path
              d="m12 4.929-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-1.133 1.133-3.109 1.133-4.242 0L10.586 12l-1.414 1.414.707.707c.943.944 2.199 1.465 3.535 1.465s2.592-.521 3.535-1.465L19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0z">
            </path>
          </svg>
        </div>
        <template v-if="account.user.indication">
          <h5 class="mb-0 ml-2">Link de licenciado</h5>
          <div class="mt-1 ml-3">
            <ShareNetwork network="whatsapp" url="" :title="referral.sponsored">
              <i class="bx bxl-whatsapp font-size-24 text-dark p-0"></i>
            </ShareNetwork>
          </div>
          <div class="mt-1 ml-2">
            <button class="btn btn-link p-0 m-0" v-clipboard:copy="referral.sponsored
              " v-on:click="$toast.success('O link foi copiado!')">
              <i class="bx bx-copy font-size-20 text-dark"></i>
            </button>
          </div>
        </template>
        <template v-else>
          <div class="py-2 ml-2">
            <h5 class="mb-0">Link de Indicação</h5>
            <router-link tag="a" to="/account/indication">
              Você ainda não possui um link de indicação, <u>clique aqui</u> para criar.
            </router-link>
          </div>
        </template>
      </div>
    </div>

    <div class="card mb-1" v-if="account.user.indication">
      <div class="card-body py-2 d-flex align-items-center">
        <div class="mt-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path
              d="M8.465 11.293c1.133-1.133 3.109-1.133 4.242 0l.707.707 1.414-1.414-.707-.707c-.943-.944-2.199-1.465-3.535-1.465s-2.592.521-3.535 1.465L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.122-2.121z">
            </path>
            <path
              d="m12 4.929-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-1.133 1.133-3.109 1.133-4.242 0L10.586 12l-1.414 1.414.707.707c.943.944 2.199 1.465 3.535 1.465s2.592-.521 3.535-1.465L19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0z">
            </path>
          </svg>
        </div>
        <h5 class="mb-0 ml-2">Link de auto cadastro de cliente</h5>
        <div class="mt-1 ml-3">
          <ShareNetwork network="whatsapp" url="" :title="referral.clients">
            <i class="bx bxl-whatsapp font-size-24 text-dark p-0"></i>
          </ShareNetwork>
        </div>
        <div class="mt-1 ml-2">
          <button class="btn btn-link p-0 m-0" v-clipboard:copy="referral.clients
            " v-on:click="$toast.success('O link foi copiado!')">
            <i class="bx bx-copy font-size-20 text-dark"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="card" v-if="account.user.indication">
      <div class="card-body py-2 d-flex align-items-center">
        <div class="mt-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path
              d="M8.465 11.293c1.133-1.133 3.109-1.133 4.242 0l.707.707 1.414-1.414-.707-.707c-.943-.944-2.199-1.465-3.535-1.465s-2.592.521-3.535 1.465L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.122-2.121z">
            </path>
            <path
              d="m12 4.929-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-1.133 1.133-3.109 1.133-4.242 0L10.586 12l-1.414 1.414.707.707c.943.944 2.199 1.465 3.535 1.465s2.592-.521 3.535-1.465L19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0z">
            </path>
          </svg>
        </div>
        <h5 class="mb-0 ml-2">Link de auto cadastro de usina</h5>
        <div class="mt-1 ml-3">
          <ShareNetwork network="whatsapp" url="" :title="referral.usinas">
            <i class="bx bxl-whatsapp font-size-24 text-dark p-0"></i>
          </ShareNetwork>
        </div>
        <div class="mt-1 ml-2">
          <button class="btn btn-link p-0 m-0" v-clipboard:copy="referral.usinas
            " v-on:click="$toast.success('O link foi copiado!')">
            <i class="bx bx-copy font-size-20 text-dark"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div v-for="(stat, index) of statData" :key="index" class="col-md-6">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-6">
        <fieldset class="card-h-fix">
          <legend>
            Bonificações <sup class="font-weight-light">{{ month_year }}</sup>
          </legend>
          <div class="d-flex justify-content-center card-h-fix">
            <ChartBonus />
          </div>
        </fieldset>
      </div>
      <div class="col-md-12 col-lg-6">
        <fieldset class="card-h-fix">
          <legend>
            Pedidos <sup class="font-weight-light">{{ month_year }}</sup>
          </legend>
          <div class="d-flex justify-content-center card-h-fix">
            <ChartOrders />
          </div>
        </fieldset>
      </div>
    </div>

    <b-modal id="informative-highlight" v-model="informative.modal" modal-class="modal-center" :title="informative.title" size="xl" hide-footer centered large>
      <router-link tag="a" :to="'/informatives/' + informative.id">
        <img :src="informative.cover" />
      </router-link>
    </b-modal>
  </Layout>
</template>

<style>
#informative-highlight .modal-dialog {
  justify-content: center;
}
#informative-highlight .modal-header {
  border-bottom: none;
  padding: 10px 15px 0px;
}
#informative-highlight .modal-content {
  width: auto;
}
#informative-highlight .modal-body {
  padding: 5px;
  text-align: center;
}
#informative-highlight img {
  max-height: 90vh;
}
</style>